import React, { useState } from 'react';
import Logout from '@mui/icons-material/Logout';
import { Avatar, Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Header } from '@/components/layout';
import { Env } from '@/config/env';
import { company, sysName, topContent, version } from './styles';
import { userInfoStore } from '@/models';

const UserMenu = observer(() => {
  const { UserName, logout } = userInfoStore;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleLogout = () => {
    logout();
    location.replace('/');
  };

  if (UserName === undefined || UserName === null) {
    handleLogout();
  }
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  return (
        <Box>
            <IconButton onClick={handleClick} size='small' sx={{ ml: 2 }}>
                <Avatar sx={{ width: 32, height: 32 }}>{UserName[0]}</Avatar>
                <Typography variant='body2' sx={company}>{UserName}</Typography>
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                id='account-menu'
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                        <Logout fontSize='small'/>
                    </ListItemIcon>
                    <ListItemText>退出賬號</ListItemText>
                </MenuItem>
            </Menu>
        </Box>
  );
});

const LayoutHeader = () => {
  return (
        <Header>
            <Box sx={topContent}>
                <Box>
                    <Typography variant='h5' sx={sysName}>
                        Sjfood Web
                    </Typography>
                    <Typography variant='body2' sx={version}>v{Env.version}</Typography>
                </Box>
                <UserMenu/>
            </Box>
        </Header>
  );
};

export default LayoutHeader;
